import { render, staticRenderFns } from "./identification.vue?vue&type=template&id=9712c314&scoped=true&"
import script from "./identification.vue?vue&type=script&lang=js&"
export * from "./identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9712c314",
  null
  
)

export default component.exports